import React from 'react'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'

const styles = {
    textField : {
        marginTop: 0,
    },
    inputWrapper : {
        '&:before' : {
            borderBottom: '1px solid #C7C7C7',
            '&::hover' : {
                borderBottom: '1px solid red',
            }
        },
    },
    input : {
        border: '1px solid #C7C7C7',
        paddingLeft: 5,
        color: '#676767',
        marginTop: 6,
        backgroundColor : '#fff',
        '&:disabled' : {
            color : '#9E9E9E',
            backgroundColor : '#FCFCFC'
        }
    },
    label : {
        color : '#3CA7AC',
        fontSize : 18,
        fontWeight: 600,
        textTransform: 'capitalize',
    }
}

const TextInput = (props) => {
    const {
        classes,
        input,
        label,
        type,
        inputProps,
        meta: { touched, invalid, error },
        required,
        ...custom
    } = props
    return (
        <TextField
            className={classes.textField}
            label={label}
            type={type}
            placeholder={"-"}
            error={touched && invalid}
            helperText={touched && invalid && error}
            required={required}
            margin="normal"
            fullWidth={true}
            InputProps={{
                className : classes.inputWrapper,
                inputProps : {
                    className : classes.input
                }
            }}
            InputLabelProps={{
                shrink: true,
                className : classes.label
              }}
            {...input}
            {...custom}
          />
    )
}

export default withStyles(styles)(TextInput)
